var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a3.43 3.43 0 0 0-3.433 3.428A3.43 3.43 0 0 0 12 9.855a3.43 3.43 0 0 0 3.433-3.427A3.43 3.43 0 0 0 12 3M9.569 6.428A2.43 2.43 0 0 1 12 4a2.43 2.43 0 0 1 2.431 2.428A2.43 2.43 0 0 1 12 8.855a2.43 2.43 0 0 1-2.431-2.427",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.844 10.947c-1.857 0-3.336.79-4.34 2.053C5.51 14.252 5 15.945 5 17.753V21h1.001v-3.247c0-1.63.462-3.09 1.289-4.132.818-1.03 2.01-1.674 3.554-1.674h2.312c1.544 0 2.736.644 3.554 1.674.827 1.041 1.288 2.501 1.288 4.132V21H19v-3.247c0-1.808-.51-3.501-1.505-4.753-1.004-1.264-2.482-2.053-4.339-2.053z"
  })));
};
export default SvgUser;